export enum ReportsQueryStoreKeys {
  DATE_RANGE = 'date-range',
  DATE_RANGE_TYPE = 'date-range-type',
  CHART_GRAIN = 'chart-grain',
  CHART_TYPE = 'chart-type',
  FILTERS = 'filters',
  BREAKDOWN = 'breakdown',
}
